export default {
  methods: {
    propsFor(componentName, props = this.$props) {
      const component = this.$options.components[componentName];

      if (component && component.props) {
        const keys = Object.keys(component.props);
        return keys.reduce((newProps, key) => ({ ...newProps, [key]: props[key] }), {});
      }
      return {};
    },
  },
};
